module.exports = __webpack_public_path__ + "img/index-empty.69a9735e.png";